import { Navigate, useParams } from 'react-router-dom';

/**
 * Old pipeline-scoped route /leads/pipeline/:pipelineId (CLE-191). The Pipeline
 * page now shows every pipeline as a tab, so this only forwards existing links
 * to that tab.
 */
export function LeadsBoardPage() {
  const { pipelineId } = useParams<{ pipelineId: string }>();
  return <Navigate to={pipelineId ? `/leads?pipeline=${pipelineId}` : '/leads'} replace />;
}
